<h1 class="h3 mb-2 text-gray-800">Solicitudes</h1>
<!-- <p class="mb-4">DataTables is a third party plugin that is used to generate the demo table below. For more information
    about DataTables, please visit the <a target="_blank" href="https://datatables.net">official DataTables
        documentation</a>.</p> -->

<!-- DataTales Example -->
<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Solicitudes</h6>
    </div>
    <div class="card-body">
        <form name="form" (ngSubmit)="f.form.valid && enviarRespuesta()" #f="ngForm">
            <div class="form-group">
                <label>Información Solicitada</label>
                <p>{{solicitud.texto_solicitud}}</p>
            </div>
            <div class="form-group">
                <label>Respuesta</label>
                <textarea class="form-control" name="texto_respuesta" [(ngModel)]="solicitud.texto_respuesta"
                    #textoRespuesta="ngModel" [ngClass]="{'is-invalid':  f.submitted && textoRespuesta.invalid}"
                    required></textarea>
                <div *ngIf="f.submitted && textoRespuesta.invalid" class="invalid-feedback">
                    <div *ngIf="textoRespuesta.errors.required">La respuesta es requerida</div>
                </div>
            </div>
            <div class="form-group">
                <label>Ingresar archivos</label>
                <app-multifile (selectedFile)="archivosSeleccionados($event)"></app-multifile>
            </div>
            <div class="form-group">
                <!-- <button type="submit" class="btn btn-primary" (click)="guardarDatos()">Guardar datos</button> -->
                <button type="submit" class="btn btn-success">Enviar respuesta</button>
                <a [routerLink]="[ '/casos/'+ solicitud.caso_id+'/solicitudes' ]" class="btn btn-link">Volver</a>
            </div>
        </form>
    </div>
</div>